export default function primaryColor() {
  // also defined in /layouts/_variables.scss
  return 'magenta'
}
